<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="chapter-title">
      Указания по ведению журнала
    </div>

    <p>
      Журнал бетонных работ ведется лицами, ответственными за выполнение этих работ и заполняется во время
      производства бетонных работ ежемесячно.
    </p>
    <p>
      По окончании ведения журнала бетонных работ он сдаётся в производственно-технический отдел строительной
      организации, который делает отметку о приемке в табл. 4 общего журнала работ.
    </p>
    <n-items v-if="project">
      <n-input title="Представитель технического надзора" v-bind="$form.input('4.1')" :text="!editable" />
      <n-input title="Представитель авторского надзора" v-bind="$form.input('4.2')" :text="!editable" />
      <n-input title="Начальник участка (ст. прораб)" v-bind="$form.input('4.3')" :text="!editable" />
      <n-input title="Начальник производственно-технического отдела" v-bind="$form.input('4.4')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter4',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
    &::v-deep {
      .n-table .row.header .cell {
        min-width: 100px;
      }
    }
  }
</style>
